import WarningModal from './WarningModal'
export default WarningModal
